export default __webpack_public_path__ + "9e0ba8ea215923410d05d48dbaf32df3.png";